module.exports = __webpack_public_path__ + "r-v3/img/auto.ea717e68.jpg";